module.exports = __webpack_public_path__ + "board-d398e2e3560979d78d9662163d296d4c.png";